import { t } from '@if/core/i18n'
import { EDecision } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import { useFeatureFlags } from '@src/api/FeatureSwitch-api'
import { useMerchantById } from '@src/api/merchants-api'
import { Loader } from '@src/components'
import ApprovedPrequalForm from './components/ApprovedPrequalForm'
import DeclinedPrequalForm from './components/DeclinedPrequalForm'
import FailedToObtainCreditReportForm from './components/FailedToObtainCreditReportForm'

interface Props {
  creditApp: FilteredCreditApplication
}

const PrequalResultPage = ({ creditApp }: Props) => {
  const decision = creditApp.prequalificationDecision?.decision
  const applicantHasReport = creditApp.applicant.hasCreditReport
  const coapplicantHasReport = creditApp.coapplicant?.hasCreditReport ?? true

  const [featureFlags, isFetchingFS] = useFeatureFlags()
  const [merchant, isLoadingMerchant] = useMerchantById(creditApp.merchantId)
  if (isFetchingFS || isLoadingMerchant || !merchant || merchant === undefined)
    return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />

  return (
    <div>
      {decision === EDecision.Approved && (
        <ApprovedPrequalForm
          creditApp={creditApp}
          merchant={merchant}
          useConfigurablePromoCodeByPlan={featureFlags?.useConfigurablePromoCodeByPlan ?? false}
        />
      )}
      {decision === EDecision.Refused && applicantHasReport && coapplicantHasReport && (
        <DeclinedPrequalForm creditApp={creditApp} />
      )}
      {decision === EDecision.Refused && (!applicantHasReport || !coapplicantHasReport) && (
        <FailedToObtainCreditReportForm creditApp={creditApp} />
      )}
    </div>
  )
}

export default PrequalResultPage
